var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageTitle',{attrs:{"title":"ポイントをもらいました"}}),_c('PointGet',{attrs:{"pointText":((_vm.point.name) + "ポイントを" + (_vm.point.amount) + "ポイントもらいました"),"buttonText":"ホームへもどる"},on:{"handleClick":function () {}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }